export enum SimplePlanStatus {
  Unknown = 0,
  Stopped = 1,
  Running = 2
}
